import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'size',
    '[style.height.px]': 'size',
  },
})
export class LoadingAnimationComponent {
  @Input() size = 16;
  @Input() color: 'neutral' | 'white' = 'neutral';
}
